import { useContext } from 'react';
import type { FullscreenContextType } from '#/app/providers/FullscreenProvider';
import FullscreenContext from '#/app/providers/FullscreenProvider/FullscreenContext';

const useFullscreen = (): FullscreenContextType => {
  return useContext(FullscreenContext);
};

export default useFullscreen;
